import React from 'react';

import { Section, SectionTitle } from 'react-scale/components';
import Grid42 from 'react-scale/components/elements/new-features';

const FeaturesSection = ({ overtitle, title, subtitle, features, cols, id, bg, paddingTop }) => (
  <Section id={id} container={false} bg={bg} paddingTop={paddingTop}>
    <div className="container">
      {title && <SectionTitle overtitle={overtitle} title={title} subtitle={subtitle} />}
      <Grid42 cols={cols} features={features} />
    </div>
  </Section>
);

FeaturesSection.defaultProps = {
  cols: 2
};

export default FeaturesSection;
